import axios from 'axios';

import { APPLY_API_ENDPOINT } from 'constants/api';

const applyAPI = axios.create({
  baseURL: APPLY_API_ENDPOINT,
});

export default applyAPI;
